<template>
  <button
    type="button"
    :style="styleProps"
    class="circle outline-0 no-underline cursor-pointer size-[22px] rounded-[3px]"
    :class="{
      'border border-solid border-white': colorName === selectedColor,
    }"
    @click="onChangeTheme"
  />
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import updater from '../../../vuex/project/updater.js';

const store = useStore();

const props = defineProps({
  colorValue: {
    type: String,
    default: null,
  },
  colorName: {
    type: String,
    default: null,
  },
  selectedColor: {
    type: String,
    default: null,
  },
});

const selectedElements = computed(
  () => store.getters['project/config/elements/getSelections']
);
const selectedNotes = computed(
  () => store.getters['project/config/notes/getSelections']
);
const selectedBranches = computed(
  () => store.getters['project/config/branches/getSelections']
);
const selectedConnections = computed(
  () => store.getters['project/config/connections/getSelections']
);
const styleProps = computed(() => ({ background: props.colorValue }));

const updateElement = value => {
  store.dispatch('project/data/elements/customUpdate', value);
};

const updateNote = value => {
  store.dispatch('project/data/notes/customUpdate', value);
};

const updateBranch = value => {
  store.dispatch('project/data/branches/customUpdate', value);
};

const updateConnection = value => {
  store.dispatch('project/data/connections/customUpdate', value);
};

const setDefaultConnectionStyle = value => {
  store.dispatch('project/data/connections/setDefaultStyle', value);
};

const setDefaultElementStyle = value => {
  store.dispatch('project/config/elements/setDefaultStyle', value);
};

const setDefaultNoteStyle = value => {
  store.dispatch('project/config/notes/setDefaultStyle', value);
};

const setDefaultBranchStyle = value => {
  store.dispatch('project/config/branches/setDefaultStyle', value);
};
const emit = defineEmits(['clickEvent']);

const onChangeTheme = event => {
  const theme = props.colorName;

  emit('clickEvent');

  selectedElements.value.forEach(id => {
    updateElement({
      id,
      props: { theme },
      apply: false,
    });
  });
  selectedNotes.value.forEach(id => {
    updateNote({
      id,
      props: { theme },
      apply: false,
    });
  });
  selectedBranches.value.forEach(id => {
    updateBranch({
      id,
      props: { theme },
      apply: false,
    });
  });
  selectedConnections.value.forEach(id => {
    updateConnection({
      id,
      props: { theme },
      apply: false,
    });
  });

  if (selectedElements.value.length > 0) {
    setDefaultElementStyle({ props: { theme }, apply: false });
  }
  if (selectedNotes.value.length > 0) {
    setDefaultNoteStyle({ props: { theme }, apply: false });
  }
  if (selectedBranches.value.length > 0) {
    setDefaultBranchStyle({ props: { theme }, apply: false });
  }
  if (selectedConnections.value.length > 0) {
    setDefaultConnectionStyle({ props: { theme }, apply: false });
  }
  updater.complete({ apply: true });
};
</script>
